<div *ngIf="!isLoggedIn" class="d-flex justify-content-between footer-position pr-5 pl-5 pt-4 footer-section"
  [ngClass]="{'postlogin-footer': isLoggedIn}">
  <div>
    <img [src]="isLoggedIn ? '/assets/images/footer/call-2.png' : '/assets/images/footer/call.png'"
      loading="lazy" /><span class="bridgeplus pl-2">
      {{contactDetails?.call}}</span>
    <img [src]="isLoggedIn ? '/assets/images/footer/email-2.png' : '/assets/images/footer/email.png'" class="pl-5"
      loading="lazy" /><span class="bridgeplus pl-2"> <a [href]="'mailto:'+contactDetails?.email">
        {{contactDetails?.email}} </a></span>
  </div>
  <div class="justify-content-end copyright1 pt-1">
    Copyright © 2010-{{dynamicYear}} Capitastar&#64;work. All rights reserved.
  </div>
</div>

<div *ngIf="isLoggedIn" class="d-flex justify-content-between footer-position pr-5 pl-5 pt-4 footer-section"
  [ngClass]="{'postlogin-footer': isLoggedIn}">
  <!-- <div class="justify-content-end copyright pt-1">
    Terms & Conditions
  </div> -->
  <div class="justify-content-end copyright pt-1">
    <a href="https://csworkind-cla-prod.capitaland.com/terms-condition" target="_blank">Terms & Conditions</a>
  </div>
  <div class="justify-content-end copyright pt-1">
    Copyright © {{dynamicYear}} Capitaland Services (India) Private Limited. All rights reserved.
  </div>
</div>